// /src/components/tools/memberProfileCard/PerkThemeUnderlayEffects.jsx
// FX that sit behind theme media (e.g. starry sky).

import React from 'react';
import PerkThemeStarfieldCanvas from './PerkThemeStarfieldCanvas';
import { normalizeEffectConfig } from '../../../utils/memberProfileThemeDisplay';

/**
 * @param {{ effectKeys?: string[], effectConfig?: object }} props
 */
export default function PerkThemeUnderlayEffects({
  effectKeys,
  effectConfig = null,
}) {
  const keys = Array.isArray(effectKeys) ? effectKeys : [];
  if (!keys.includes('starfield')) return null;

  const cfg = normalizeEffectConfig(effectConfig);

  return (
    <div className="perk-theme-underlay" aria-hidden>
      <PerkThemeStarfieldCanvas
        density={cfg.starfieldDensity}
        distribution={cfg.starfieldDistribution}
      />
    </div>
  );
}
